var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('span',{staticClass:"group-status-chip",class:`group-status-chip--${_vm.status.tone}`},[_vm._v(_vm._s(_vm.status.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }